
import {Component, Prop, Vue} from 'vue-property-decorator';
import {Contact} from "@/shared/domain/General";

@Component({})
export default class ContactNameComponent extends Vue {
  @Prop() contact?: Contact
}
